export const SIDE_NAV = 'sideNav'

export const sideNav = {
  en: {
    translation: {
      [SIDE_NAV]: {
        dashboard: 'Dashboard',
        projects: 'Projects',
        profile: 'Profile',
        payable: 'Payable',
        receivable: 'Receivable',
        vendors: 'Vendors',
        clients: 'Clients',
        vendorsSkills: 'Vendor Trades',
        markets: 'Markets',
        reports: 'Reports',
        performance: 'Performance',
        userMgmt: 'Users',
        administration: 'ADMINISTRATION',
        menu: 'MENU',
        alerts: 'Alerts',
        projectType: 'Locations',
        support: 'Support',
        estimates: 'Estimates',
        cypressReport: 'Cypress Report',
        property: "Property",
        workOrder: "Tickets",
        tickets: "Tickets"
      },
    },
  },
  es: {
    translation: {
      [SIDE_NAV]: {
        dashboard: 'Tablero',
        projects: 'Proyectos',
        profile: 'Perfil',
        payable: 'Pagadero',
        receivable: 'Cuenta por cobrar',
        vendors: 'Vendedores',
        clients: 'Clientes',
        vendorsSkills: 'Habilidades de los vendedores',
        markets: 'Mercados',
        reports: 'Informes',
        performance: 'Actuación',
        userMgmt: 'Usuarias',
        administration: 'Administración',
        menu: 'MENÚ',
        alerts: 'Alertas',
        projectType: 'Tipo de proyecto',
        support: 'Apoyo',
        estimates: 'estimados',
        cypressReport: 'Informes de Cypress',
        property: "Propiedad",
        workOrder: "Orden de trabajo",
        tickets: "Entradas"
      },
    },
  },
}
